import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class GetVipUsersList extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("VipUserReserve/GetListForAdmin");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class CreateVipUserReserve extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("VipUserReserve/Create");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetVipUserReserveById extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("VipUserReserve/GetById");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class UpdateVipUserReserve extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("VipUserReserve/Update");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class DeleteVipUserReserve extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("VipUserReserve/Delete");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

export {
  GetVipUsersList,
  CreateVipUserReserve,
  GetVipUserReserveById,
  UpdateVipUserReserve,
  DeleteVipUserReserve,
};
